<template>
    <div class="row gutters">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="d-flex w-100 flex-row justify-content-end mb-3 pr-1" v-if="filter">
                <div class="btn btn-primary" id="filter" data-toggle="modal" data-target="#customModalTwo"
                     @click="$emit('filter')">
                    Filtro
                </div>
            </div>
            <div class="data-list-card card">
                <div class="data-list-card__header">
                    <span class="data-list-card__title">{{ cardTitle }}</span>
                    <span class="data-list-card__count" v-if="count != null">{{ count }}</span>
                </div>
                <div class="data-list-card__body">
                    <div class="table-responsive">
                        <table class="table table-hover data-list-table mb-0">
                            <thead>
                            <tr>
                                <th class="text-center" v-for="(title, index) in titles" :key="index">{{ title }}</th>
                                <th v-if="showAction" class="text-center">
                                    <div class="d-flex justify-content-center" v-if="hasIconExport">
                                        <p class="mr-2">Ações</p>
                                        <button type="button" class="data-list-table__action-badge" title="Gerar PDF"
                                                @click="$emit('exportPdf')"><i class="material-icons-outlined">picture_as_pdf</i>
                                        </button>
                                    </div>
                                    <p v-else>Ações</p>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <slot name="tableBody"></slot>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableComponent',
    props: {
        filter: {
            type: Boolean,
            default: false,
        },
        showAction: {
            type: Boolean,
            default: true,
        },
        titles: {
            required: true,
        },
        cardTitle: {
            type: String,
            default: 'Registros',
        },
        count: {
            type: [Number, String],
            default: null,
        },
        hasIconExport: {
            type: Boolean,
           default: false,
        }
    },
    emits:['filter', 'exportPdf'],
}
</script>

<style scoped>

</style>
